import { MonsterTypes } from "../../lib/types";
import tc from 'tinycolor2';
export const convertNormalizedPath = (path, sideLength, yOffset = 0, xOffset = 0) => {
    return path.map(({ x, y }) => {
        if (x === null)
            return { x, y };
        const dimensionRatio = (sideLength / 10);
        return { x: (x * dimensionRatio) - (sideLength / 4) + (xOffset * dimensionRatio), y: (y * dimensionRatio) - (sideLength / 4) + (yOffset * dimensionRatio) };
    });
};
var Colors;
(function (Colors) {
    Colors["Gray"] = "#D7D7D7";
    Colors["Blue"] = "#7A96FF";
    Colors["Red"] = "#FF7A7A";
    Colors["Green"] = "#7AFF86";
    Colors["Brown"] = "#CD9F5D";
    Colors["Yellow"] = "#F1FF7A";
})(Colors || (Colors = {}));
const elementToColorMap = {
    [MonsterTypes.Physical]: Colors.Gray,
    [MonsterTypes.Water]: Colors.Blue,
    [MonsterTypes.Fire]: Colors.Red,
    [MonsterTypes.Flying]: Colors.Green,
    [MonsterTypes.Earth]: Colors.Brown,
    [MonsterTypes.Electric]: Colors.Yellow,
};
const attributeToTypeKeyMap = {
    speed: 'type',
    attack: 'subType',
    defense: 'subType',
    magic: 'subType',
    mana: 'subType',
    luck: 'both',
    health: 'type',
};
const adjustIntensity = (color, attributeValue) => {
    const tinycolor = tc(color);
    for (let i = 0; i < Math.abs(5 - attributeValue); i++) {
        if (attributeValue > 5) {
            tinycolor.darken();
        }
        else {
            tinycolor.lighten();
        }
    }
    return tinycolor.toString();
};
const generateAura = (primaryColor, secondaryColor, luck) => {
    const tinycolor = tc.mix(primaryColor, secondaryColor, 50);
    return adjustIntensity(tinycolor.complement().toString(), luck);
};
export const generateFillColor = (attribute, monster) => {
    const prop = attributeToTypeKeyMap[attribute];
    if (prop !== 'both') {
        const color = elementToColorMap[monster.serialized[prop]];
        return adjustIntensity(color, monster.serialized.baseAttributes[attribute]);
    }
    else {
        const mainColor = elementToColorMap[monster.serialized.type];
        const secondaryColor = elementToColorMap[monster.serialized.subType];
        return generateAura(mainColor, secondaryColor, monster.serialized.baseAttributes.luck);
    }
};
